import seoConfig from '~~/configs/seo.config';

/**
 * Sets default global schema.org data (e.g., organization, website).
 *
 * This composable is intended for setting static schema.org data that applies globally
 * across the site, such as the organization and website schema.
 *
 * @example
 * useDefaultSchema();
 */
export default function useDefaultSchema() {
  const { logo, defaultImage, description, sameAs, address } = seoConfig;
  const site = useSiteConfig();
  const { origin } = useRequestURL();

  // 1. Definieer een stabiel ID voor de organisatie
  const orgId = `${origin}/#organization`;

  const organizationSchema = defineOrganization({
    '@id': orgId, // Forceer dit ID
    name: site.name,
    url: 'https://eenvandaag.avrotros.nl',
    description: 'Onafhankelijke nieuwsredactie van publieke omroep AVROTROS.',
    logo: {
      url: `${origin}${logo?.src}` || '',
      width: logo?.width,
      height: logo?.height,
    },
    sameAs,
    address,
  });

  const websiteSchema = defineWebSite({
    '@id': `${origin}/#website`,
    description,
    // Koppel de website aan de organisatie als uitgever
    publisher: { '@id': orgId },
    image: {
      url: `${origin}${defaultImage?.src}`,
      width: defaultImage?.width,
      height: defaultImage?.height,
    },
  });

  useSchemaOrg([organizationSchema, websiteSchema]);
}